/**
 * WONE-612: legacy `/signup` email-entry retired in favour of the
 * unified `/email-entry`. Kept as a thin redirect so existing links
 * (e.g. marketing-page CTAs) keep working.
 */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const SignUp: React.FC = () => {
  const location = useLocation();
  return (
    <Navigate
      to={`/email-entry${location.search || ""}`}
      replace
      state={location.state}
    />
  );
};

export default SignUp;
